// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lv-0";
export var buttonContainer = "_lv-3";
export var cancelButton = "_lv-4";
export var headerSection = "_lv-6";
export var headerTitle = "_lv-9";
export var messageSideLeft = "_lv-1";
export var messageSideRight = "_lv-2";
export var orderNumberContainer = "_lv-7";
export var orderNumberLabel = "_lv-8";
export var submitButton = "_lv-5";